<template>
	<div class="container">
		<flickity ref="flickity" :options="flickityOptions" v-bind:class="{ 'notClickable' : setClickable() }" v-if="this.steps.length > 0" style="position: relative; user-select: none;" id="project_step_carrousel">

			<div class="carousel-cell text-center" v-for="(step, index) in this.steps" :key="index" :class="{
				last_completed: step.id === last_completed_id,
				music_step: step.type === 'App\\StepMusic',
				disabled: step.disabled
			}"
			>
				<a href="#" @click.prevent="(step.type !== 'Final') ? setComponent(step.type.substr(4), index) : setComponent(step.type, index)">
					<div @click="activate(index)" class="step_div" :class="{ active : active_el === index }">
						<div class="mx-auto step_in_div">
							<div class="effect"></div>
							<img v-if="step.isCompleted" width="60" :src="'./static/images/'+ step.type.substr(4).toLowerCase()+'check.png'" ref="logoStep" />
							<img v-else width="60" :src="(step.type !== 'Final') ? './static/images/'+ step.type.substr(4).toLowerCase() +'.png' : './static/images/step'+ step.type.toLowerCase() +'.png'" />
							<div class="row align-items-end">
								<div style="margin: auto" v-if="Array.isArray(step.stepName)">
									<p class="step_text">{{ step.stepName[0] }}</p>
									<p class="step_text_sub">{{ step.stepName[1] }}</p>
								</div>
								<div style="margin: auto" v-else>
									<p class="step_text" v-if="(step.type !== 'Final')">{{ $t('StepsList.' + step.translationId) }}</p>
									<p class="step_text" v-else>{{ $t('StepsList.Final') }}</p>
								</div>
							</div>
						</div>
					</div>
				</a>
			</div>

		</flickity>
	</div>
</template>

<script>
import Flickity from "vue-flickity";
import Navbar from "../ui/Navbar";

export default {
	name: "stepsCarousel",
	components: {Navbar, Flickity},
	props: {
		steps: {
			type: Array,
			"default": () => [],
		},
		setComponent: {
			type: Function,
			required: true,
		},
		active_el: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			flickityOptions: {
				initialIndex: 0,
				groupCells: 7,
				contain: true,
				prevNextButtons: true,
				wrapAround: false,
				draggable: false,
				pageDots: false,
			},
		};
	},
	computed: {
		last_completed_id: {
			get() {
				if (this.steps.findLast) {
					let last_step = this.steps.findLast(v => v.isCompleted === true);
					if (last_step !== undefined) {
						return last_step.id;
					}
				}
				return -1;
			},
		},
	},
	methods: {
		activate(el) {
			if (!this.steps[el].disabled) {
				this.active_el = el;
			}
		},
		next() {
			this.$refs.flickity.next();
		},
		previous() {
			this.$refs.flickity.previous();
		},
		setClickable() {
			return this.$route.name === "VideoEdition" || this.$route.name === "SubtitleEdition" || this.$route.name === "VoiceOverEdition";
		},
	},
};
</script>

<style scoped>

.step_div {
	width: 140px;
	height: 150px;
	padding: 1rem 0;
	border-top: 8px solid transparent;
	position: relative;
}

.step_div:hover .effect {
	width: 60px;
	height: 60px;
	position: absolute;
	box-shadow: 0 0 10px #00000080;
	border-radius: 50%;
	left: 50%;
	transform: translate(-50%);
}

.step_div img {
	position: relative;
	z-index: 3;
}

.active {
	border-top: solid var(--color-background-2) 8px !important;
}

a:hover {
	text-decoration: none;
}

.step_text {
	color: #144B5E;
	font-size: 14px;
	font-weight: bold;
	margin-top: 3px;
	margin-bottom: 0;
}

.step_text_sub {
	color: #144B5E;
	font-size: 12px;
	margin-bottom: 0;
}

.step_in_div {
	width: 100%;
}

.notClickable {
	pointer-events: none;
	background-color: white;
	opacity: 0.5;
}

/*.carousel-cell:last-child::before,*/
/*.last_completed + .carousel-cell::before,*/
.music_step::before {
	content: "";
	position: absolute;
	background: var(--color-background-2);
	width: 8px;
	height: 50px;
	border-radius: 4px;
	left: -4px;
	top: 30px;
}

.carousel-cell.disabled {
	opacity: 0.5;
}

.carousel-cell.disabled a {
	cursor: default;
}

</style>
